var $12ebd11b0414452e$exports = {};
$12ebd11b0414452e$exports = {
    "valid": `Wa\u{17C}ny`
};


export {$12ebd11b0414452e$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
